import { render, staticRenderFns } from "./vendorOrdersDashboard.vue?vue&type=template&id=9a52b11e&scoped=true"
import script from "./vendorOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./vendorOrdersDashboard.vue?vue&type=script&lang=js"
import style0 from "./vendorOrdersDashboard.vue?vue&type=style&index=0&id=9a52b11e&prod&lang=scss&scoped=true"
import style1 from "./vendorOrdersDashboard.vue?vue&type=style&index=1&id=9a52b11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a52b11e",
  null
  
)

export default component.exports